import { render, staticRenderFns } from "./LogDetalle.vue?vue&type=template&id=3d8a80d4&"
import script from "./LogDetalle.vue?vue&type=script&lang=js&"
export * from "./LogDetalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports